export enum ErrorType {
  badRequest = 'badRequest',
  databaseError = 'databaseError',
  dependencyError = 'dependencyError',
  notFound = 'notFound',
  rateLimitExceeded = 'rateLimitExceeded',
  serverError = 'serverError',
  serviceUnavailable = 'serviceUnavailable',
  unauthorized = 'unauthorized',
  unknown = 'unknown',
  dataCorruption = 'dataCorruption',
  contentTooLarge = 'contentTooLarge',
  conflict = 'conflict',
}

// Error codes generated using task: genErrorCode
export enum ErrorCode {
  accountNotSentToBilling = 'rFP2c3CSnKJ5WDte3QEgex',
  accountSystemDetailsRequired = 'kNLtAGuf9asQSbFnmD8rUP',
  badRequest = 'cprqfqwsYTkXvZeJNYUajy',
  contentTooLarge = 'kRsScGVpt4Qwke18KNHtF9',
  databaseError = 'opd7zeMrK7nDn1FnjNvjk8',
  dataCorruption1 = 'owGE2y6V9aRAtiD2i3F4Vb',
  dataCorruption2 = 'gJHEdb4kjXNkLY6VdpjdiY',
  dataCorruption3 = 'ens5WtDCXHwB6xkLFqF7iM',
  dependencyError = '4bBJDtcoh5vivUdufkkhQW',
  disclosureAcceptanceRequired = 'pfqEgUNMKv2EvJnumQahHJ',
  glideError = 'b2QjoW8VpggWhxijUw2s6F',
  inboundPaymentError = 'oMcVC8HNDMf2dWm4HyxqRh',
  illinoisShinesJobError = 'ozrwJ78xCEp7FjPweciF3i',
  heliosError = 'tswBwbmPTHiNbdiHn2SicZ',
  notFound = 'gWzq2uGN9JvLghx4sMfpcp',
  serverError = '8f87GRD6nk34XCZBHDGX1w',
  serviceUnavailable = 'xF4_36Ea8NqqRw3HNAke6I',
  unauthorized = 'vUjkVZSwJjwUM1aoTDskqM',
  rateLimitExceeded = 'h7mX3gk3ZzYF6y2J1pR9u4',
  unknown = '8XXpKEBREruCDDTXvMc8UE',
  validation = 'wknah4hS4zbX7gw85pCzyy',
  workerQueueError = 'fChp2gFRYDxy6rZnivagVp',
  applicationDuplicateEmail = '7TUuVVP3eFZpHXuB2nJV41',
  applicationPerDayLimitReached = '96QWgzbdknus8KgxCZPK2M',
  prebillingOfferContractNoSigners = 'rVsQMxkBy8iCELdwrrn7sc',
  conflict = 'erdb93mX48c5dYmDEnDPLR',
  equipmentDuplicateName = 'qPydMFLBwjbeThroSPxcws',
  equipmentDuplicateAlias = 'hFpyDzkaSn8UxuC4iuoHJK',
  equipmentManufacturerInactive = '6us5KbBvspyURi12awtbzZ',
  equipmentBrandManufacturerMismatch = '21Ag2zibguT3riWR5k73MC',
}

export interface BaseErrorInterface extends Error {
  type: ErrorType;
  code: ErrorCode;
  data?: Record<string, any>;
}
